import React from 'react'
import '../assets/css/tools.css'
function ToolsCard({img , title}) {
  return (
    <div className='tool-card'>
         <img src={img} alt="" />
         <h2>{title}</h2>
    </div>
  )
}

export default ToolsCard
